import React from "react";
import DateBox from "devextreme-react/date-box";
import TagBox from "devextreme-react/tag-box";
import { Button } from "devextreme-react/button";
import { formatMessage } from "devextreme/localization";
import { RequestStatus, changeDisplayedName } from "../../common";
import { useScreenSize } from "../../utils/media-query";
import "./style.scss";

export default function ToolbarDataGrid({
  middleware,
  filter,
  setFilter,
  handleChangeSelectBox,
}) {
  const { isXSmall, isSmall } = useScreenSize();
  return (
    <div className="form_select_box_list">
      {middleware?.ReadState && (
        <>
          <span className="name">{formatMessage("From")}: </span>
          <DateBox
            type="date"
            className="mr-1"
            width={isXSmall || isSmall ? null : 120}
            defaultValue={filter.FromDate}
            onValueChanged={(e) => setFilter({ ...filter, FromDate: e.value })}
          />
          <span className="name">{formatMessage("To")}: </span>
          <DateBox
            type="date"
            className="mr-1"
            width={isXSmall || isSmall ? null : 120}
            defaultValue={filter.ToDate}
            onValueChanged={(e) => setFilter({ ...filter, ToDate: e.value })}
          />
          <span className="name">{formatMessage("Status")}: </span>
          <TagBox
            items={RequestStatus}
            width={isXSmall || isSmall ? null : 300}
            showSelectionControls={true}
            applyValueMode="useButtons"
            displayExpr={changeDisplayedName()}
            valueExpr="id"
            selectAllMode="allPages"
            maxDisplayedTags={2}
            showMultiTagOnly={false}
            className="mr-1 tag-box-ecap"
            value={filter.Status}
            onValueChanged={(e) => {
              setFilter({ ...filter, Status: e.value });
            }}
          />

          <Button
            icon="revert"
            text={formatMessage("View")}
            onClick={handleChangeSelectBox}
          />
        </>
      )}
    </div>
  );
}
